import React from 'react';

/** Monday first, matching the weekday numbers payroll uses (Monday = 0). */
export const WEEKDAYS = [
  { value: 0, label: 'Mon' },
  { value: 1, label: 'Tue' },
  { value: 2, label: 'Wed' },
  { value: 3, label: 'Thu' },
  { value: 4, label: 'Fri' },
  { value: 5, label: 'Sat' },
  { value: 6, label: 'Sun' },
];

/**
 * The days that are not worked. Payroll divides by the days that are, so a
 * six-day week paid on a five-day divisor gets the per-day rate wrong for
 * everybody — which is why this is worth a control rather than an API call.
 *
 * `value` is an array of weekday numbers; `null` means "not set here".
 */
const WeekOffPicker = ({ value, onChange, disabled = false, id = 'week-off' }) => {
  const selected = new Set(value || []);

  const toggle = (day) => {
    const next = new Set(selected);
    if (next.has(day)) next.delete(day); else next.add(day);
    // Every day off means no working days to divide by, so the last one stays.
    if (next.size >= 7) return;
    onChange([...next].sort((a, b) => a - b));
  };

  return (
    <div id={id} className="flex flex-wrap gap-1.5">
      {WEEKDAYS.map((day) => {
        const on = selected.has(day.value);
        return (
          <button
            key={day.value}
            type="button"
            disabled={disabled}
            aria-pressed={on}
            onClick={() => toggle(day.value)}
            className={`h-8 min-w-[3rem] rounded-md border px-2 text-xs font-medium transition-colors disabled:opacity-50 ${
              on
                ? 'border-primary bg-primary/10 text-primary'
                : 'border-input bg-background text-muted-foreground hover:bg-accent'
            }`}
          >
            {day.label}
          </button>
        );
      })}
    </div>
  );
};

export default WeekOffPicker;
